module.exports = __webpack_public_path__ + "static/BambooHR-45e914f59ce3db8160a739df4dad4f2e.png";